import { CashMovementReconciliationRecordDto } from './CashMovementReconciliationRecordDto';

export class CashMovementReconciliationDto {
  id: number;
  valueDate: Date;
  records: Array<CashMovementReconciliationRecordDto>;
}
